// going to start grouping timeouts in here so they don't clutter
// up the global config as much.
import getGlobalObject from './getGlobalObject';
const global = getGlobalObject();

export default {
    loginRetryAfterUserBusy: global.LOGIN_RETRY_AFTER_USER_BUSY ?? 10000 //mills (10 seconds)
};
